import componentFn from '../../styles/objects/component'

export default ({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
}) => {

    const component = componentFn({
        colors,
        spacings,
        images,
        fontFamilies,
        fontWeights,
        fontSizes,
        textTransforms
    })

    const styles = {
        image: {
            width: '1.3rem',
            height: '1rem',
            margin: '-0.2rem auto',
            backgroundColor: '#cecece',
            padding: '0.06rem'
        },
        flagInput: {
            cursor: 'default',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            paddingRight: '0.6rem'
        },
        countryCodeComponent: {
            float: 'left'
        }
    }

    return { ...component, ...styles }
} 


// WEBPACK FOOTER //
// ./components/countryCode/styles.js